import * as jose from "jose";
import config from "../../utils/config/config";
import { SOCKET } from "./initWebSocket";

{/* Generates a JWT token using provided user and session data.*/ }
export const onGenerateToken = async ({ email, sessionId, platform, appType }) => {
    const payload = { email, mobileSession: sessionId, platform, appType };

    try {
        const secret = new TextEncoder().encode(config.TokenSecretKey);
        const jwt = await new jose.SignJWT(payload)
            .setProtectedHeader({ alg: "HS256" })
            .setExpirationTime("24h")
            .sign(secret);

        return jwt;
    } catch (error) {
        console.error("JWT token error : ", error)
        return error;
    }
};

{/** Starts a conversation via socket with provided user and bot parameters.*/ }
export const startConversation = (userId, { conversationId = "", botId = "" }) => {
    const conversation = {
        conversationId,
        bot: botId,
        participants: [userId],
        onChannels: [],
        closed: false,
    };

    const messagePayload = {
        messageType: "init",
        message: {
            intentId: "main",
            OsVersion: "",
            brand: "",
            model: "",
            platform: "",
            userAgent: "",
        },
    };

    socketStartConversationEvent(messagePayload, conversation);
};

{/** Emits the conversation start event to the socket.*/ }
const socketStartConversationEvent = (messagePayload, conversation) => {
    const payload = {
        capability: "BackendBotCap",
        parameters: JSON.stringify({
            command: "sendMessage",
            botId: conversation.bot,
            data: messagePayload,
        }),
        sync: false,
        conversation
    };

    SOCKET.socketClient.emit('agent-guard:execute', payload);
};

{/** Emits another events to the socket.*/ }
export const socketSendMessageEvent = (parametersData, conversation) => {
    const payload = {
        capability: "BackendBotCap",
        parameters: JSON.stringify({
            "command": "sendMessage",
            "botId": conversation?.bot,
            "data": parametersData,
        }),
        sync: false,
        conversation: {
            conversationId: conversation?.conversationId,
            bot: conversation?.bot,
        },
    };

    console.log("%c Sending messages by user to socket :", "color: green;", payload)
    SOCKET.socketClient.emit('agent-guard:execute', payload, (ack) => {
        console.log('ACK from server:', ack);
    });
};
